module.exports = __webpack_public_path__ + "img/license-active.3e9c940d.svg";